const token = 'CAPSCRM';

export class LocalStorage {
  namespace;

  constructor(namespace = 'default', clear = false) {
    this.namespace = token + '_' + namespace;
    this.init(clear);
  }

  /**
   * init store if it not exists
   *
   * @memberof Storage
   */
  init(clear) {
    if (clear || !localStorage.getItem(this.namespace)) {
      localStorage.setItem(this.namespace, JSON.stringify({}));
    }
  }

  /**
   * get item from storage
   *
   * @param {string} [name] if empty - return full store
   * @returns
   * @memberof Storage
   */
  getItem(name = undefined) {
    let data = localStorage.getItem(this.namespace);
    if (data) {
      data = JSON.parse(data);
    }
    if (!name) {
      return data;
    }
    return data && data[name] ? data[name] : undefined;
  }

  /**
   * set item to storage
   *
   * @param {*} name
   * @param {*} val
   * @memberof Storage
   */
  setItem(name, val) {
    const data = this.getItem();
    data[name] = val;
    localStorage.setItem(this.namespace, JSON.stringify(data));
  }

  clear() {
    localStorage.setItem(this.namespace, JSON.stringify({}));
  }
}

export const getLocalStorage = (name, clear = false) => {
  return new LocalStorage(name, clear);
};
